import { Button, Stack, Typography } from '@mui/material';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { useFailedSendCreditTransactionsTable } from '@Modal/hooks/failedSendCreditTransactionsTable.ts/useFailedSendCreditTransactionsTable';

export const FailedSendCreditTransactionsTitle: React.FC = () => {
  const { clearRoundTableFiltersHandler, failedSendCreditTransactionsTableFilters } =
    useFailedSendCreditTransactionsTable();
  const objectVals = Object.values(failedSendCreditTransactionsTableFilters);
  const disabled = objectVals.length === 0 || objectVals.every((val) => val === undefined);

  return (
    <AtLocator type="container" name="ProviderTransactionsListTitle">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingBottom: 2 }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h3">Failed Send Credit Transactions</Typography>
        </Stack>
        <AtLocator type="button" name="clearFilters">
          <Button
            size="large"
            variant="contained"
            disabled={disabled}
            onClick={clearRoundTableFiltersHandler}
          >
            Clear filters
          </Button>
        </AtLocator>
      </Stack>
    </AtLocator>
  );
};
